import type { LineItem, Money, ShippingInfo, TaxedPrice } from "@graphql/generated/types";
import { Box } from "@ecco/ui/box";
import { space } from "@ecco/ui/tokens";
import AccordionBagList from "./accordion-bag-list/AccordionBagList";
import { StaticBagList } from "./static-bag-list/StaticBagList";
import Summary from "./summary/Summary";

import type { JSX } from "react";

export const container = "bag-list-summary-container";
interface BagOverviewProps {
    productsList: LineItem[];
    locale: string;
    discount: Money;
    cartTotalPrice: Money;
    subtotalPrice: Money;
    cartTaxedPrice?: TaxedPrice;
    shippingInfo: ShippingInfo;
    bagHeader: string;
    totalQuantity: number;
    withPromoCodeSection?: boolean;
    setCartOrSessionChanged?: (cartOrSessionChanged: boolean) => void;
    cartOrSessionChanged?: boolean;
    usedDiscountCodeIds?: string[];
}

const BagOverview = ({
    productsList,
    cartTotalPrice,
    subtotalPrice,
    shippingInfo,
    discount,
    locale,
    cartTaxedPrice,
    bagHeader,
    totalQuantity,
    withPromoCodeSection,
    setCartOrSessionChanged,
    cartOrSessionChanged,
    usedDiscountCodeIds,
}: BagOverviewProps): JSX.Element => {
    const getSummary = () => (
        <Box bg={"white"} mt={space["0.2"]} data-testid="bagoverview">
            <Summary
                locale={locale}
                shippingInfo={shippingInfo}
                cartTotalPrice={cartTotalPrice}
                cartTaxedPrice={cartTaxedPrice}
                subtotalPrice={subtotalPrice}
                cartDiscount={discount}
                setCartOrSessionChanged={setCartOrSessionChanged}
                cartOrSessionChanged={cartOrSessionChanged}
                withPromoCodeSection={withPromoCodeSection}
                usedDiscountCodeIds={usedDiscountCodeIds}
                isCheckout={true}
            />
        </Box>
    );

    return (
        <Box data-testid={container} w={"100%"}>
            <StaticBagList
                productsList={productsList}
                locale={locale}
                headerText={bagHeader}
                totalQuantity={totalQuantity}
            >
                {getSummary()}
            </StaticBagList>
            <AccordionBagList
                productsList={productsList}
                locale={locale}
                headerText={bagHeader}
                totalQuantity={totalQuantity}
            >
                {getSummary()}
            </AccordionBagList>
        </Box>
    );
};

export default BagOverview;
